import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@fluentui/react';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { enum_CONTACTPARTIE_POLINOMY_FORM_VIEW } from '../../../../common/Dictionaries';
import { useDispatch, useSelector } from 'react-redux';
import DeleteAdvaiceDialog from '../../../../pages/sPay/ContractParties/Dialogs/DeleteAdvaiceDialog';
import { useTranslation } from 'react-i18next';
import './style.css'
import { __calculateTotalRestAdjustmentAmount } from '../../../../common/CommonFuctions';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';

const TablePolynomyItem = ({ parentId, tableItem, parentPolinomyType, polynomyViewType, addCardWidth = false, handleDeletePolynomy, handleDeletePolynomyClickAux, itemBodyClass='', itemClass = 'w-20', setTotalRestAdjustmentAmount = null, l_POLINOMIO }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    _contractPresentation: contractPresentation,
    _contractParties: contractParties,
  } = useSelector((state) => state.contractPartiesState);

  const [showDeleteAdvice, setShowDeleteAdvice] = useState(false);

  const customStyles = {
    root: {
      selectors: {
        ':hover': {
          backgroundColor: 'transparent',
        },
        ':focus': {
          backgroundColor: 'transparent',
        },
        ':active': {
          backgroundColor: 'transparent',
        },
      },
    },
  };

  const handleDeletePolynomyClick = (responseFlag, tableItemId, parentType) =>{
    if (responseFlag) {
      const result = handleDeletePolynomy && handleDeletePolynomy(dispatch, tableItemId, parentType, parentId, contractParties, t);
      if (result) {
        l_POLINOMIO = l_POLINOMIO.filter(x => x.id !== tableItemId)
        setTotalRestAdjustmentAmount && setTotalRestAdjustmentAmount(__calculateTotalRestAdjustmentAmount(l_POLINOMIO));
      }
    }
  }

  const handleDeletePolynomyClick2 = (responseFlag, tableItemId, parentType) =>{
    if (responseFlag) {
      const result = handleDeletePolynomyClickAux && handleDeletePolynomyClickAux(tableItemId, parentId, contractParties);
      if (result) {
        l_POLINOMIO = l_POLINOMIO.filter(x => x.id !== tableItemId)
        setTotalRestAdjustmentAmount && setTotalRestAdjustmentAmount(__calculateTotalRestAdjustmentAmount(l_POLINOMIO));
      }
    }
  }

  const handlePreDeleteClick = () => {
    setShowDeleteAdvice(true);
  }

  return (
          <Card className={'polinomio poliAzul m-1 ' + (addCardWidth ? itemClass : 'w-100')}>
            <Card.Body className={itemBodyClass}>
              {
                polynomyViewType === enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.SIMPLE_VIEW &&
                <Row>
                  <Col>
                    <Row><Col>{t('data-lang-lbl-contractpartie-index')}</Col></Row>
                    <Row><Col>{tableItem.tipoPolinomioTitle}</Col></Row>
                  </Col>
                  <Col style={{fontSize: "30px"}}>{tableItem.ponderador}%</Col>
                </Row>
              }
              {
                (polynomyViewType === enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_VEW || polynomyViewType === enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT) &&
                <>
                  {
                    (polynomyViewType === enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT && (contractPresentation.estado_partida_abierta && contractPresentation.estado_contrato_modificable)) &&
                    <IconButton styles={customStyles} className="cierrePolinomio mb-2" onClick={handlePreDeleteClick} iconProps={{iconName: 'ErrorBadge'}}/>
                  }
                  <div style={
                    polynomyViewType === enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.COMPLEX_EDIT ? 
                      {fontSize: "10px", width: "99%", float: "left", position: "relative", top: "-25px"} :
                      {fontSize: "10px", width: "99%", position: "relative", top: "-10px"}
                    }>
                      <Row className='pb-1'>
                          <Col xl={4} className="montoIndice tdBottom"><span>{tableItem.ponderador != null ? tableItem.ponderador : "0"} %</span></Col>
                          <Col className="col-auto me-auto txtIndice tdBottom"><span> {tableItem.tipoPolinomioTitle} </span></Col>
                      </Row>
                      <Row>
                          <Col className='pe-0'>{t('data-lang-lbl-contractpartie-basedate')}</Col>
                          <Col className='pe-0'>{t('data-lang-lbl-contractpartie-monthadjustment')}</Col>
                          <Col className='pe-0'>{t('data-lang-lbl-contractpartie-monthlag')}</Col>
                      </Row>
                      <Row className='pb-1'>
                          <Col><span>{moment(tableItem.fechaBase).format('DD/MM/YYYY')}</span></Col>
                          <Col><span>{tableItem.primerMesReajuste}</span></Col>
                          <Col><span>{tableItem.mesesDesfase !== null ? tableItem.mesesDesfase :  "-"}</span></Col>
                      </Row>
                      <Row>
                          <Col>{t('data-lang-btn-basevalue')}</Col>
                          <Col>{t('data-lang-lbl-contractpartie-frecuency')}</Col>
                          <Col>&nbsp;</Col>
                      </Row>
                      <Row>
                          <Col><span>{tableItem.valorBase !== null ? tableItem.valorBase : "-"}</span></Col>
                          <Col><span>{tableItem.periodicidadMeses}</span></Col>
                          <Col>&nbsp;</Col>
                      </Row>
                  </div>
                </>
              }
              {
                <DeleteAdvaiceDialog
                  isModalOpen={showDeleteAdvice}
                  setIsModalOpen={setShowDeleteAdvice}
                  setterAction={isNullUndefinedOrEmpty(handleDeletePolynomyClickAux) ? handleDeletePolynomyClick : handleDeletePolynomyClick2}
                  itemIdToDelete={tableItem.id}
                  parentType={parentPolinomyType}
                />
              }
            </Card.Body>
          </Card>
  );
};

TablePolynomyItem.propTypes = {
  tableItem: PropTypes.shape({
    id: PropTypes.number,
    tipoPolinomioTitle: PropTypes.string,
    fechaBase: PropTypes.string,
    mesesDesfase: PropTypes.number,
    partidaId: PropTypes.number,
    periodicidadMeses: PropTypes.number,
    ponderador: PropTypes.number,
    primerMesReajuste: PropTypes.string,
    subpartidaId: PropTypes.number,
    tipoPolinomioId: PropTypes.number,
    valorBase: PropTypes.number
  }),
  polynomyViewType: PropTypes.number
};

TablePolynomyItem.defaultProps = {
  tableItem: {
    id: 0,
    tipoPolinomioTitle: "Título",
    fechaBase: null,
    mesesDesfase: null,
    partidaId:  0,
    periodicidadMeses: null,
    ponderador:  null,
    primerMesReajuste: null,
    subpartidaId: null,
    tipoPolinomioId: 0,
    valorBase: null,
  },
  polynomyViewType: enum_CONTACTPARTIE_POLINOMY_FORM_VIEW.SIMPLE_VIEW
};

export default TablePolynomyItem;
